/**
 * Created by Jerker Nord on 2023-07-05.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Loner} from "../Loner";
import {gsap} from "gsap";
import {LonerSound} from "../sound/LonerSound";
import {LonerGameAssets} from "../LonerGameAssets";
import {LonerSpine} from "../components/LonerSpine";

export class LonerAnticipationView extends PIXI.Container implements StageLayer {

    private static SCATTER_ANIMATION_POSITION: PIXI.Point = new PIXI.Point(644, 300);
    private static SCATTER_ANIMATION_NAME: string = "anticipation";

    private _scatterAnimation: LonerSpine;
    private _activateScatterTL: gsap.core.Timeline;
    private _deActivateScatterTL: gsap.core.Timeline;
    private _isScatterActive: boolean = false;

    constructor() {
        super();
        this.name = "LonerAnticipationView";
        this.init();
    }

    private init(): void {
        this.visible = false;

        this._scatterAnimation = new LonerSpine(Loner.assetLoader.getSpineAsset(LonerGameAssets.SCATTER_ANTICIPATION_SPINE));
        this._scatterAnimation.position = LonerAnticipationView.SCATTER_ANIMATION_POSITION;
        this._scatterAnimation.alpha = 0;
        this.addChild(this._scatterAnimation);

        this._scatterAnimation.state.setAnimation(0, LonerAnticipationView.SCATTER_ANIMATION_NAME, true);

        this._activateScatterTL = gsap.timeline({paused: true});
        this._activateScatterTL.add(()=>{
            this.visible = true;
        });
        this._activateScatterTL.add(() => {
            if(!Loner.isGodModeRound){
                Loner.soundPlayer.playSound(LonerSound.SCATTER_ANTICIPATION);
            }
            this._scatterAnimation.alpha = 0;
        });
        this._activateScatterTL.add([
            gsap.to(this._scatterAnimation, {duration: 0.2, alpha: 1}),
        ]);

        this._deActivateScatterTL = gsap.timeline({paused: true});
        this._deActivateScatterTL.add(() => {
            this._scatterAnimation.alpha = 1
        });
        this._deActivateScatterTL.add([
            gsap.to(this._scatterAnimation, {duration: 0.1, alpha: 0}),
        ]);
        this._deActivateScatterTL.add(()=>{
           this.visible = false;
        });
    }

    public activateScatterAnticipation(): void {
        this._isScatterActive = true;
        this._activateScatterTL.restart();
    }

    public deActivateScatterAnticipation(): void {
        if (this._isScatterActive) {
            this._isScatterActive = false;
            this._deActivateScatterTL.restart();

            Loner.soundPlayer.fadeAndStopSound({
                name: LonerSound.SCATTER_ANTICIPATION,
                to: 0,
                duration: 300
            });
        }
    }
}